import { gql } from '@apollo/client';

const LOGOUT = gql`
  mutation logout {
    logout
  }
`;

export default LOGOUT;
